import { useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { getCompanyCollaborators } from "../../services/clientCollaborators.service";
import styles from "./css/clientCollaboratorsModal.module.css";

export default function ClientCollaboratorsModal({ show, companyId, onClose }) {
  const [collaborators, setCollaborators] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleGetCollaborators = async () => {
      try {
        if (!show || !companyId) return;

        setLoading(true);
        setError(null);

        const data = await getCompanyCollaborators({ companyId });
        setCollaborators(data);

      } catch (err) {
        console.error("ERROR - GET COMPANY COLLABORATORS FUNCTION:", err);
        setCollaborators([]);
        setError("Nao foi possivel carregar os colaboradores no momento.");

      } finally {
        setLoading(false);
      }
    };

    handleGetCollaborators();
  }, [show, companyId]);

  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(event) => event.stopPropagation()}>
        <header className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Colaboradores da empresa</h2>

          <button type="button" className={styles.closeButton} onClick={onClose}>
            <IoMdCloseCircle size={24} color="#2f3e49" />
          </button>
        </header>

        <div className={styles.modalBody}>
          {loading ? (
            <p>Carregando colaboradores...</p>

          ) : error ? (
            <p>{error}</p>

          ) : collaborators.length === 0 ? (
            <p>Nenhum colaborador encontrado para esta empresa.</p>

          ) : (
            <div className={styles.listArea}>
              {collaborators.map((item) => (
                <article key={item.id} className={styles.listItem}>
                  <p><b>Nome:</b> {item.name}</p>
                  <p><b>Cargo:</b> {item.cargo}</p>
                  <p><b>Email:</b> {item.email}</p>
                  <p><b>Telefone:</b> {item.phone}</p>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
